import { useCallback } from "react"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useNavigate } from "react-router-dom"
import { APP_STATUS, updateAppStatus } from "utils/electron"

import { useTranslation } from "providers/i18n"
import { useHome } from "hooks/home/useHome"

import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { PageCard } from "components/card"
import { NearMeIcon } from "components/icons"
import { SidebarMenu } from "extensions/iconsiam/components/navigation/kiosk-h/SidebarMenu"
import { formbricksTrack } from "extensions/iconsiam/utils"
import { ContentWithAside } from "layouts/kiosk-h"

export const HomeWithScreenSaverPage = ({
  Layout = ContentWithAside,
  AppNavigation = DefaultAppNavigation,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { defaultRoutePath } = useHome()

  const base = theme.components?.[`HomePage`]?.styleOverrides ?? {}
  const variant =
    theme.components?.[`HomeWithScreenSaverPage`]?.styleOverrides ?? {}
  const {
    actionContainer,
    actionButton,
    welcomeContainer,
    touchToStartText,
    touchToStartIcon,
    pageCard,
    contentContainer,
  } = deepmerge(base, variant)

  const handleClick = useCallback(() => {
    formbricksTrack("touch_to_start_kiosk")
    updateAppStatus(APP_STATUS.ACTIVE)
    navigate(defaultRoutePath)
  }, [navigate, defaultRoutePath])

  return (
    <Layout
      aside={
        <PageCard>
          <SidebarMenu AppNavigation={AppNavigation} />
        </PageCard>
      }
    >
      <PageCard sx={pageCard}>
        <Box sx={contentContainer}>
          <Box sx={welcomeContainer}>
            <Box sx={actionContainer}>
              <Button sx={actionButton} onClick={handleClick}>
                <NearMeIcon sx={touchToStartIcon} />
                <Typography sx={touchToStartText}>
                  {t("Touch to start")}
                </Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      </PageCard>
    </Layout>
  )
}
